import apiClient from "../apiClient";

//................. Sidebar Api's...................//

export const getChangePassword = (data) =>
  apiClient.post("/Auth/change-password", data);

//................. Tenant Profile Api's...................//

export const getTenantProfileData = () => apiClient.get("/tenant/profile");

//................. Dashboard Api's...................//

export const getTenantDashboardData = () =>
  apiClient.get("/tenant/dashboard", {});

export const updateTenantProfileData = (data) =>
  apiClient.post("/tenant/profile/update", data);

//................. Tenant Vacate Api's...................//

export const getVacateNoticeData = () => apiClient.get("/tenant/vacate-notice");

export const createVacateNotice = (data) =>
  apiClient.post("/tenant/vacate-notice/submit", data);

export const cancelVacateNotice = (id) =>
  apiClient.post(`/tenant/vacate-notice/${id}/cancel`);

export const getVacateNoticeSetting = () =>
  apiClient.get("/tenant/vacate-notice/settings");

//................. Tenant Support Ticket Api's...................//

export const getSupportTicketCategories = () =>
  apiClient.get("/master/ticket-categories");

export const getSupportTicketData = () =>
  apiClient.get("/tenant/support-tickets");

export const createSupportTicket = (data) =>
  apiClient.post("/tenant/support-tickets/create", data);

export const getSupportTicketById = (id) =>
  apiClient.get(`/tenant/support-tickets/${id}`);

export const getMessagesSupportTicketById = (id) =>
  apiClient.get(`/tenant/support-tickets/${id}/messages`);

export const replyMessagesSupportTicket = (data) =>
  apiClient.post("/tenant/support-tickets/message", data);

//................. KYC Document Api's...................//

export const getKycDocList = () =>
  apiClient.get("/tenant/kyc-documents");

export const uploadKycDoc = (ownerDocId, coTenantId, file) => {
  const form = new FormData();
  form.append("OwnerDocId", ownerDocId);
  form.append("CoTenantId", coTenantId ?? 0);
  form.append("file", file);
  return apiClient.post("/tenant/kyc-documents/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
 
export const deleteKycDoc = (tenantKYCDocId) =>
  apiClient.post(`/tenant/kyc-documents/${tenantKYCDocId}/delete`);

